var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { assertNever } from "../assertNever";
var RUS = {
    hi: "Привет, ",
    menu: "Меню",
    quests: "Квесты",
    options: "Опции",
    installMode: "Приложение",
    installModeInstalling: "Загрузка",
    installModeNeedReload: "Готово обновление",
    login: "Войти",
    useown: "Загрузить .qm/.qmm",
    loginWith: "Войти через",
    authConnectedTo: "Привязан к",
    authConnectTo: "Привязать к",
    profile: "Профиль",
    loginInfo: "Вход в систему позволяет синхронизировать опции и пройденные квесты на разных устройствах",
    topplayers: "Чемпионы",
    logout: "Выйти",
    waitForFirebase: "Ждем ответа от firebase",
    firebaseSyncing: "Синхронизация с firebase",
    doFirebaseSync: "Выполнить синхронизацию с firebase",
    // showingName: "Имя пользователя",
    // showingNameDesc: "Это имя будет в общем списке",
    minutesShort: "мин.",
    ranger: "Рейнджер",
    fromPlanet: "С планеты",
    fromStar: "С системы",
    toPlanet: "Прилетел на планету",
    toStar: "В системе",
    defaultCompensation: "Награда за квест",
    enableBackButton: "Кнопка назад",
    backButtonDisabled: "Выключена (нормальный режим)",
    backButtonEnabled: "Включена (читерский режим)",
    debugButtonEnabled: "Включен режим отладки",
    lang: "Язык/Language",
    rus: "Русский",
    eng: "English",
    save: "Сохранить",
    saving: "Сохраняю",
    welcomeHeader: "Добро пожаловать в онлайн плеер квестов!",
    all: "Все",
    own: "Загруженные",
    search: "Поиск",
    nothingFound: "Ничего не найдено",
    //startRandomUnpassed: "Выбрать случайный из непройденного",
    allQuestPassed: "Все квесты пройдены!",
    passed: "Пройден",
    startFromTheStart: "Начать сначала",
    startFromLastSave: "Загрузить сохранение",
    noLastSave: "Нет сохранения",
    loading: "Загрузка",
    loadingIndex: "Загрузка индекса",
    loadingLocalDatabase: "Загрузка локальной базы данных",
    reloading: "Перезагрузка",
    loadingQuest: "Загрузка квеста",
    restart: "Начать сначала",
    stepBack: "Шаг назад",
    reallyRestart: "Начать сначала?",
    toggleMusic: "Музыка",
    toggleFullscreen: "На весь экран",
    exit: "Выход",
    yes: "Да",
    no: "Нет",
    back: "Назад",
    backToList: "К списку квестов",
    installEngineNotStarted: "Ожидание регистрации оффлайн режима",
    installingEngine: "Установка оффлайн режима для приложения",
    installingEngineUpdate: "Идет фоновое обновление",
    installEngineError: "Приложение не установлено, оффлайн режим недоступен",
    engineInstalledNeedReload: "Приложение установлено, нажмите здесь для перезапуска в оффлайн режиме",
    engineUpdatedNeedReload: "Обновление установлено, нажмите здесь для перезапуска",
    engineInstalledAndInOfflineMode: "Приложение установлено и работает в оффлайн режиме",
    storageIsPersisted: "Хранилище устойчивое, браузер не удалит",
    storageIsNotPersisted: "Хранилище неустойчивое, браузер может удалить. " +
        "Можно попробовать добавить приложение на главный экран или добавить в закладки",
    storePersistedIsUnknown: "Статус устойчивости хранилища неизвестен",
    cacheImagesMusicInfo: "По-умолчанию для оффлайн режима устанавливаются только код и текстовые квесты, " +
        "это сделано для того, чтобы не занимать много места на устройстве. " +
        "Картинки и музыку можно установить отдельно здесь",
    images: "Картинки",
    musicAndSound: "Музыка и звуки",
    installing: "Установка",
    installed: "Установлено",
    uninstall: "Удалить",
    notInstalled: "Не установлено",
    install: "Установить",
    storageUsed: "Использовано",
    storageUsedFrom: "из",
    storageUsageUnavailable: "Статус использования хранилища недоступен",
    about: "О приложении",
    builtAt: "Сборка",
    linkForBugreports: "Сообщения об ошибках можно оставлять в багтрекере Github-а или на Pikabu",
    validatingInfo: "Прохождения проверяются, это займёт какое-то время",
    validationComplete: "Проверка завершена. Показываются проверенные результаты",
    championsDisabled: "Таблица чемпионов временно не работает из-за лимитов firebase",
    championName: "Имя рейнджера",
    championWonGames: "Пройдено квестов",
    championGameNames: "Список пройденный квестов",
    championNoName: "<Имя не задано>",
    validatingQuest: "Проверяем прохождение",
    questValidationErrorsInfo: "Есть ошибки валидации. Это означает что " +
        "квест был пройден на старой браузерозависимой версии движка и нужно пройти этот квест еще раз",
    championsTotal: "Загружено чемпионов:",
    championsLoading: "Загрузка списка чемпионов",
    pwaInstallHeader: "Веб-приложение",
    pwaInstallInfoLink: "Нажми здесь",
    pwaInstallInfoToAddToDesktop: " чтобы закончить установку и создать ярлык на рабочем столе",
    pwaInstallOk: "Установка приложения началась!",
    pwaInstallNotOk: "Не получилось установить",
    editor: "Редактор",
    debug: "Отладка",
    debugCopyState: "Скопировать состояние",
    debugSetState: "Установить состояние",
    debugStepBack: "Шаг назад",
    debugClose: "Закрыть",
};
var ENG = {
    hi: "Hi, ",
    menu: "Menu",
    quests: "Quests",
    options: "Option",
    installMode: "Application",
    installModeInstalling: "Downloading",
    installModeNeedReload: "Update ready",
    login: "Log in",
    useown: "Upload .qm/.qmm",
    loginWith: "Log in with",
    authConnectedTo: "Connected to",
    authConnectTo: "Connect to",
    profile: "Profile",
    loginInfo: "The entry to the systems allows to synchronize options and quests completed between different devices",
    topplayers: "Champions",
    logout: "Log out",
    waitForFirebase: "Waiting for firebase",
    firebaseSyncing: "Synchronizing with firebase",
    doFirebaseSync: "Sync data with firebase",
    // showingName: "Имя пользователя",
    // showingNameDesc: "Это имя будет в общем списке",
    minutesShort: "min.",
    ranger: "Ranger",
    fromPlanet: "From the planet",
    fromStar: "From the system",
    toPlanet: "Arrived at the planet",
    toStar: "In the system",
    defaultCompensation: "Default compensation",
    enableBackButton: "Back button",
    backButtonDisabled: "Disabled (normal mode)",
    backButtonEnabled: "Enabled (cheater mode)",
    debugButtonEnabled: "Debug mode enabled",
    lang: "Язык/Language",
    rus: "Русский",
    eng: "English",
    save: "Save",
    saving: "Saving",
    welcomeHeader: "Welcome to the online quest player!",
    all: "All",
    own: "Uploaded",
    search: "Search",
    nothingFound: "Nothing is found",
    //startRandomUnpassed: "Choose a randome quest from those you have not completed",
    allQuestPassed: " All quests are completed!",
    passed: "Complete",
    startFromTheStart: "Start over",
    startFromLastSave: "Start saving",
    noLastSave: "No saving",
    loading: "Loading",
    loadingIndex: "Loading index",
    loadingLocalDatabase: "Loading local database",
    reloading: "Reloading",
    loadingQuest: "Quest loading",
    restart: "Restart",
    stepBack: "Step back",
    reallyRestart: "Really restart?",
    toggleMusic: "Music",
    toggleFullscreen: "Fullscreen",
    exit: "Exit",
    yes: "Yes",
    no: "No",
    back: "Back",
    backToList: "Back to quests",
    installEngineNotStarted: "Waiting for offline mode registration",
    installingEngine: "Offline application mode is being installed",
    installingEngineUpdate: "Background updating is underway",
    installEngineError: "The application is not installed, offline mode is unavailable",
    engineInstalledNeedReload: "The application is installed, click here to reload offline mode",
    engineUpdatedNeedReload: "The update is installed, click here to reload",
    engineInstalledAndInOfflineMode: "The application is installed and working in an offline mode",
    storageIsPersisted: "The storage is persisted, browser won't delete this",
    storageIsNotPersisted: "The storage is not persisted, browser may delete this. " +
        "You can try to add the app to the main screen or add to bookmarks",
    storePersistedIsUnknown: "Storage persisted status is unknown",
    cacheImagesMusicInfo: "Only code and text quests are installed for offline mode by default. " +
        "This has been done to save space on your device. " +
        "Pics and music can be installed separately here",
    images: "Pictures",
    musicAndSound: "Music and sound",
    installing: "Installing",
    installed: "Installed",
    uninstall: "Uninstall",
    notInstalled: "Not installed",
    install: "Install",
    storageUsed: "Storage is using",
    storageUsedFrom: "from",
    storageUsageUnavailable: "Storage usage is unavailable",
    about: "About",
    builtAt: "Built at",
    linkForBugreports: "You can add a bugreport into Github bug tracker or into Pikabu",
    validatingInfo: "Quest game passing is validating. Please be patient",
    validationComplete: "Validation is complete. Only validated results are shown now",
    championsDisabled: "Championship table is temporarely disabled due to firebase limits",
    championName: "Ranger's name",
    championWonGames: "Amount of passed quests",
    championGameNames: "Список пройденный квестов",
    championNoName: "<Name is not set>",
    validatingQuest: "Checking passing",
    questValidationErrorsInfo: "Validation errors are present. This means that " +
        "the quest was passed using old brower-depend engine and it needs to be passed again",
    championsTotal: "Loaded champions:",
    championsLoading: "Loading list of champions",
    pwaInstallHeader: "Web application",
    pwaInstallInfoLink: "Click here",
    pwaInstallInfoToAddToDesktop: " to finish installation and to add to homescreen",
    pwaInstallOk: "Application installation started!",
    pwaInstallNotOk: "Failed to install application",
    editor: "Editor",
    debug: "Debug",
    debugCopyState: "Copy state",
    debugSetState: "Set state",
    debugStepBack: "Step back",
    debugClose: "Close",
};
export function getLang(lang) {
    if (lang === "rus") {
        return RUS;
    }
    else if (lang === "eng") {
        return ENG;
    }
    else {
        return assertNever(lang);
    }
}
function isBot() {
    if (!window.indexedDB) {
        return true;
    }
    if (navigator.webdriver) {
        return true;
    }
    if (/bot|google|baidu|bing|msn|teoma|slurp|yandex/i.test(navigator.userAgent)) {
        return true;
    }
    if (/spider|crawl|APIs-Google|AdsBot|Googlebot|mediapartners|Google Favicon|FeedFetcher/i.test(navigator.userAgent)) {
        return true;
    }
    if (/Google-Read-Aloud|DuplexWeb-Google|googleweblight|duckduck|yahoo|ecosia|ia_archiver|facebook/i.test(navigator.userAgent)) {
        return true;
    }
    if (/instagram|pinterest|reddit|slack|twitter|whatsapp|youtube|semrush/i.test(navigator.userAgent)) {
        return true;
    }
    return false;
}
function guessBrowserLang() {
    var e_1, _a;
    // tslint:disable-next-line:strict-type-predicates
    if (typeof navigator === "undefined") {
        // To run inside tests
        return "rus";
    }
    if (isBot()) {
        // Это чтобы индексировалась русская версия
        return "rus";
    }
    var browserLanguages = navigator.languages || [
        navigator.language || navigator.userLanguage || "ru",
    ];
    console.info("languages=" + (navigator.languages ? navigator.languages.join(",") : "null") + " " +
        ("language=" + navigator.language + " ") +
        ("userLanguage=" + navigator.userLanguage + " browserLanguages=" + browserLanguages.join(",")));
    try {
        for (var browserLanguages_1 = __values(browserLanguages), browserLanguages_1_1 = browserLanguages_1.next(); !browserLanguages_1_1.done; browserLanguages_1_1 = browserLanguages_1.next()) {
            var browserLang = browserLanguages_1_1.value;
            if (browserLang.indexOf("ru") === 0) {
                return "rus";
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (browserLanguages_1_1 && !browserLanguages_1_1.done && (_a = browserLanguages_1.return)) _a.call(browserLanguages_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (!window.indexedDB) {
        // Чтобы google русский вариант индексировал
        return "rus";
    }
    return "eng";
}
export var browserDefaultLang = guessBrowserLang();
//# sourceMappingURL=data:application/json;base64,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